import { app } from '../../../bootstrap/core';
import stockListComponent from './stockList.component';
import partCalculatorComponent from './partCalculator/partCalculator.component';

app.component('stockList', stockListComponent);
app.component('partCalculator', partCalculatorComponent);



// WEBPACK FOOTER //
// ./src/app/common/ui/stockList/stockList.js